<div class="box">
  <!-- <p style="color: white; font-size: 11px; margin-left: 10px; margin-top: 4px">
    Simulations: {{ simAmount }} ({{ credits | number : '' : 'de' }} C)
  </p> -->

  <!-- <p style="color: white; font-size: 11px; margin-left: 10px; margin-top: 4px">{{ projectName }}</p> -->
  <p *ngIf="simAmount <= 1" style="color: white; font-size: 12px; margin-left: 10px; margin-top: 4px">
    {{ simAmount }} Version
  </p>

  <p *ngIf="simAmount > 1" style="color: white; font-size: 12px; margin-left: 10px; margin-top: 4px">
    {{ simAmount }} Versions
  </p>

  <mat-icon
    (click)="toggleFavourite(project.is_favorite || false)"
    tooltip="Set favorite"
    *ngIf="!project.is_favorite"
    [style.right]="starMargin"
    style="color: white; font-size: 22px; position: absolute; bottom: 5px; top: 2px"
  >
    star_border
  </mat-icon>

  <mat-icon
    (click)="toggleFavourite(project.is_favorite || false)"
    tooltip="Remove favorite"
    *ngIf="project.is_favorite"
    [style.right]="starMargin"
    style="color: white; font-size: 22px; position: absolute; bottom: 5px; top: 2px"
  >
    star
  </mat-icon>

  <mat-icon
    [tooltip]="'Share project'"
    (click)="openShareDialog(project.uuid)"
    [style.right]="shareMargin"
    style="color: white; font-size: 20px; position: absolute; bottom: 5px; top: 3px"
  >
    share
  </mat-icon>

  <usimweb-project-menu
    *ngIf="showOptions"
    [color]="'white'"
    [project]="project"
    (dialogEvent)="dialogEvent($event)"
    (updateSupported)="updateSupported($event)"
    style="position: absolute; right: 5px; top: -1px"
  ></usimweb-project-menu>
</div>
